import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'next-i18next';
import Indicator from '@features/ui/components/Indicator';

const EventTabLiveTiming = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <Indicator />
      {t('eventTabLiveTiming_inProgress.message')}
    </Container>
  );
};

export default EventTabLiveTiming;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
